import { render, staticRenderFns } from "./CommunityNotifications.vue?vue&type=template&id=76533b73&scoped=true&"
import script from "./CommunityNotifications.vue?vue&type=script&lang=ts&"
export * from "./CommunityNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityNotifications.vue?vue&type=style&index=0&id=76533b73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76533b73",
  null
  
)

export default component.exports